/* eslint react/no-direct-mutation-state: "off", eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup, Table } from 'reactstrap';
import { SendInvoiceEmail } from '../../../../../action/invoiceAction';
import ErrorGif from '../../../../../Assets/images/Error.gif';

let Email = "^(([a-zA-Z0-9]|[!#$%&'*+/=?^_`{|}~-])[\\.]?)*([a-zA-Z0-9]+[!#$%&'*+/=?^_`{|}~-]*|[a-zA-Z0-9]*[!#$%&'*+/=?^_`{|}~-]+)[@]{1}([a-zA-Z0-9_-]*([\\.]?[a-zA-Z0-9_]+)+)$";
class SendEmail extends Component {

    // componentDidMount() {
    //     if (this.props.selectedInvoices != undefined && this.props.selectedInvoices != null && this.props.selectedInvoices.length == 1){
    //         this.state.subject = false
    //     }
    // }

    constructor(props) {
        super(props);
        this.state = {
            iserror: false,
            subject: true,
            isAddressErr: false,
            isCCAddressErr: false
        }
        this.SendInvoiceEmail = this.SendInvoiceEmail.bind(this);
        this.HandleRadio = this.HandleRadio.bind(this);
    }

    SendInvoiceEmail() {
        this.setState({ iserror: false });
        
        if (this.ValidateEmail()) {
            var invoices = [];
            this.props.selectedInvoices.forEach(element => {
                invoices.push(element.artifactName + ((element.isExcelFormat == true) ? '.xlsx' : '.pdf'));
            });

            var data = {
                "emailAddress": (this.refs.emailid.value.length > 0 ? this.refs.emailid.value + (this.refs.ccemailid.value.length > 0 ? "|" + this.refs.ccemailid.value : ""): "") ,
                "emailContent": this.refs.message.value,
                "emailSubject": this.refs.subject.value,
                "invoices": invoices,
                "isChangeRequestEmail": false
            }

            this.props.SendInvoiceEmail(data);
            this.props.CloseModal();
            this.setState({ iserror: true });
        }
        else{
            this.setState({ iserror: true });
        }
    }

    ValidateEmail(){
        let l_Return = true;
        this.state.isAddressErr = false;
        this.state.isCCAddressErr = false;
        if (this.refs.emailid.value == '')
        {
            l_Return = false;
            this.state.isAddressErr = true;
        }
        else {
            var emaillist = this.refs.emailid.value.split(";");
            if(emaillist.length > 0){
                emaillist.forEach(element => {
                    if(element != '' && !element.match(Email))
                    {
                        l_Return = false;
                        this.state.isAddressErr = true;
                    }
                });
            }
            var ccemaillist = this.refs.ccemailid.value.split(";");
            if(ccemaillist.length > 0){
                ccemaillist.forEach(element => {
                    if(element != '' && !element.match(Email))
                    {
                        l_Return = false;
                        this.state.isCCAddressErr = true;
                    }
                });
            }
        }
        return l_Return;
    }

    HandleRadio(){
        if(this.refs.radio.checked){
            this.setState({ subject: true });
        }
        else{
            this.setState({ subject: false });
        }
    }

    render(getLabels) {
        let Selected_Invoice_Data = "<tr><td colSpan='2'>No Records Found</td></tr>", single_Invoice = false, subject_text='', message_text = '',error = '',error_image='',error_image_cc='',checkbox_disable=false;
        var CloseModal = this.props.CloseModal;
        let label = this.props.getLabels;

        if (this.state.iserror) {
            error = <p className="error_msg">
                <img src={ErrorGif} alt="Trane Logo" />
                {label['NonNumberError.Text']}
            </p>

            if(this.state.isAddressErr){
            error_image = <p className="error_img">
                <img src={ErrorGif} alt="Trane Logo" />
            </p>
            }

            if(this.state.isCCAddressErr){
                error_image_cc = <p className="error_img">
                    <img src={ErrorGif} alt="Trane Logo" />
                </p>
            }
        }

        if (this.props.selectedInvoices != undefined && this.props.selectedInvoices != null && this.props.selectedInvoices.length > 0) {
            single_Invoice = (this.props.selectedInvoices.length == 1) ? true : false;
            subject_text = (this.props.selectedInvoices.length == 1) ? 'Invoice: '+this.props.selectedInvoices[0].invoiceNumber : '';

            if(this.props.selectedInvoices.length == 1)
            {
                var l_dateGenerated = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(this.props.selectedInvoices[0].dateGenerated))
                var l_startDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(this.props.selectedInvoices[0].invoiceStartDate))
                var l_endDate = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(this.props.selectedInvoices[0].invoiceEndDate))
                message_text = 'The attached invoice contains the detail for the invoiced billing period as follows: \n\n Tenant \t\t\t\t '+this.props.selectedInvoices[0].tenantName+' \n Billing Period \t\t\t '+ l_startDate+' - '+l_endDate +' \n Invoice Date \t\t\t '+l_dateGenerated+' \n Invoice Number \t\t '+this.props.selectedInvoices[0].invoiceNumber+' \n Invoice Amount \t\t '+Number(this.props.selectedInvoices[0].totalAmount).toFixed(2);
            }

            Selected_Invoice_Data = this.props.selectedInvoices.map((el, i) => (
                <tr Key={i}>
                    <td>{el.invoiceNumber}</td>
                    <td>{el.dateGenerated}</td>
                </tr>
            ));
        }

        checkbox_disable = single_Invoice && this.state.subject;

        return (
            <div >

                <h4 className="Modal_form_title">{label['TenantInvoicesEmail.lblSendEmailHeader.Text']}</h4>

                {error}

                <div className="Modal_form_group_textbelow_input" style={{'clear':'both'}}>
                    <label className="Modal_label"><span className="label_with_bg"> To:</span></label>
                    <div  className="Modal_input_div ">
                    <input className=" default-input Modal_input_textbelow" ref='emailid' type="text"/>
                      <p className="modal_text_below_input">{label['TenantInvoicesEmail.lblEmailRecipientUAText.Text']}</p>
                    </div>
                    {error_image}
                </div>

                   <div className="Modal_form_group_textbelow_input ">
                    <label className="Modal_label"><span className="label_with_bg"> Cc:</span></label>
                    <div  className="Modal_input_div ">
                    <input className=" default-input Modal_input_textbelow" ref='ccemailid' type="text"/>
                    {/* <FormGroup check>
                            <Label check> */}
                                <input type="checkbox" id="NormalHours" ref='radio' onChange={this.HandleRadio} disabled={!single_Invoice} defaultChecked={single_Invoice}  />{' '}
                               {label['TenantInvoicesEmail.lblReportNameAsSubject.Text']}
                                     {/* </Label>
                        </FormGroup> */}
                    </div>
                    {error_image_cc}
                </div>

                   <div className="Modal_form_group ">
                    <label className="Modal_label">{label['TenantInvoicesEmail.lblEmailSubject.Text']}</label>
                    <input className="Modal_input default-input" ref='subject' disabled={checkbox_disable} defaultValue={subject_text} type="text"/>
                </div>

                <div className="Modal_form_group ">
                    <label className="Modal_label">{label['TenantInvoicesEmail.lblEmailMessage.Text']}</label>
                    <textarea className="Modal_input default-input" ref='message' defaultValue={message_text}/>
                </div>

                    <legend className="form_sub_title">{label['TenantInvoicesEmail.lblAttachment.Text']}</legend>

                    <div className="Modal_table_Conatiner">



                    <Table striped responsive className="Modal_table">

                        <tbody>
                            <tr className="Modal_table_header">
                                <th>{label['TenantInvoicesEmail.Column.InvoiceNumber.Text']}</th>
                                <th>{label['TenantInvoicesEmail.Column.InvoiceDate.Text']}</th>
                            </tr>
                            {Selected_Invoice_Data}
                        </tbody>
                    </Table>

                    </div>

                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-gray btn-md" onClick={() => CloseModal()} > {label['Buttons.Cancel.Text']} </Button>
                            <Button className="btn-success btn-md" onClick={this.SendInvoiceEmail} >{label['Buttons.Send.Text']}</Button>
                        </Col>
                    </FormGroup>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SendInvoiceEmail: (data) => dispatch(SendInvoiceEmail(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEmail);



